import React from 'react';

import { Image } from '@lt/components';

import { i18n } from '@lt/localization';
import logoPng from 'src/images/logo/logo.png';
import logoWebp from 'src/images/logo/logo.webp';
import classnames from 'classnames';
import styles from './appInformation.module.css';
import { BannerStars } from '../BannerStars/BannerStars';

type Props = {
  reviewsCountText: string;
  className?: string;
  rating: number;
};

export const AppInformation = ({
  className,
  reviewsCountText,
  rating,
}: Props): JSX.Element => (
  <div className={classnames(styles.container, className)}>
    <Image
      className={styles.logo}
      src={logoWebp}
      fallback={logoPng}
      alt="Level.Travel logo"
    />
    <div className={styles.content}>
      <p className={styles.title}>
        {i18n.t('mobile_apps_banner.app_information.title')}
      </p>
      <p className={styles.description}>
        {i18n.t('mobile_apps_banner.app_information.description')}
      </p>
      <BannerStars reviewsCountText={reviewsCountText} rating={rating} />
    </div>
  </div>
);
